export async function getPOCToolSummaries() {
  const response = await fetch('/api/PointOfCareTools/', {
    method: 'GET',
  });
  if (!response.ok) {
    throw response.status;
  }
  return response.json();
}

export async function getPOCToolById(id: string) {
  const response = await fetch(`/api/PointOfCareTools/${id}`, {
    method: 'GET',
  });
  if (!response.ok) {
    throw response.status;
  }
  return response.json();
}

export async function getMiniPOCToolById(id: string) {
  const response = await fetch(`/api/PointOfCareTools/miniTools/${id}`, {
    method: 'GET',
  });
  if (!response.ok) {
    throw response.status;
  }
  return response.json();
}

export async function getContentByMiniToolId(POCToolId, minitoolId) {
  const response = await fetch(
    `/api/PointOfCareTools/miniTools/${POCToolId}/${minitoolId}`,
    {
      method: 'GET',
    },
  );
  if (!response.ok) {
    throw response.status;
  }
  return response.json();
}
